import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "64",
      height: "64",
      fill: "none",
      rx: "4"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "#000",
      d: "m18 16 32 16-32 16z"
    }, null, -1)
  ]))]))
}
export default { render: render }